import { messages as contractTypeManageMessages } from '../views/contract/contractTypeManageLang'
import { messages as contractTypeSpecManageMessages } from '../views/contract/contractTypeSpecManageLang'
import { messages as contractPartyaManageMessages } from '../views/contract/contractPartyaManageLang'
import { messages as newContractManageMessages } from '../views/contract/newContractManageLang'
import { messages as printContractMessages } from '../views/contract/printContractLang'
import { messages as addContractMessages } from '../views/contract/addContractLang'
import { messages as contractManageMessages } from '../views/contract/contractManageLang'
import { messages as contractChangeManageMessages } from '../views/contract/contractChangeManageLang'
import { messages as contractChangeDetailMessages } from '../views/contract/contractChangeDetailLang'
import { messages as expirationContractManageMessages } from '../views/contract/expirationContractManageLang'
import { messages as contractDetailMessages } from '../views/contract/contractDetailLang.js'
import { messages as contractChangeDetailsMessages } from '../views/contract/contractChangeDetailsLang'
import { messages as contractApplyAuditOrdersMessages } from '../views/contract/contractApplyAuditOrdersLang'
import { messages as contractChangeAuditOrdersMessages } from '../views/contract/contractChangeAuditOrdersLang.js'
import { messages as contractApplyAuditHistoryOrdersMessages } from '../views/contract/contractApplyAuditHistoryOrdersLang'
import { messages as contractChangeAuditHistoryOrdersMessages } from '../views/contract/contractChangeAuditHistoryOrdersLang'
import { messages as contractDetailChangeMessages } from '../views/contract/contractDetailChangeLang'
import { messages as contractApplyDetailMessages } from '../views/contract/contractApplyDetailLang'

export const messages ={
    en:{
        ...contractTypeManageMessages.en,
        ...contractTypeSpecManageMessages.en,
        ...contractPartyaManageMessages.en,
        ...newContractManageMessages.en,
        ...printContractMessages.en,
        ...addContractMessages.en,
        ...contractManageMessages.en,
        ...contractChangeManageMessages.en,
        ...contractChangeDetailMessages.en,
        ...expirationContractManageMessages.en,
        ...contractDetailMessages.en,
        ...contractChangeDetailsMessages.en,
        ...contractApplyAuditOrdersMessages.en,
        ...contractChangeAuditOrdersMessages.en,
        ...contractApplyAuditHistoryOrdersMessages.en,
        ...contractChangeAuditHistoryOrdersMessages.en,
        ...contractDetailChangeMessages.en,
        ...contractApplyDetailMessages.en,
    },
    zh:{    
        ...contractTypeManageMessages.zh, 
        ...contractTypeSpecManageMessages.zh,
        ...contractPartyaManageMessages.zh,
        ...newContractManageMessages.zh,
        ...printContractMessages.zh,
        ...addContractMessages.zh,
        ...contractManageMessages.zh,
        ...contractChangeManageMessages.zh,
        ...contractChangeDetailMessages.zh,
        ...expirationContractManageMessages.zh,
        ...contractDetailMessages.zh,
        ...contractChangeDetailsMessages.zh,
        ...contractApplyAuditOrdersMessages.zh,
        ...contractChangeAuditOrdersMessages.zh,
        ...contractApplyAuditHistoryOrdersMessages.zh,
        ...contractChangeAuditHistoryOrdersMessages.zh,
        ...contractDetailChangeMessages.zh,
        ...contractApplyDetailMessages.zh,
}
}